module.exports = __webpack_public_path__ + "static/Verity_Logo2024_TM_RGB_Inverse-fccf9ed95232ee9d1b8f60b49f5780ac.png";